<app-header></app-header>

<!-- <main>
    <router-outlet></router-outlet>
</main>
<app-footer></app-footer>  -->
<!-- <app-header  [item]='navURL'></app-header> -->
<main>
    <router-outlet></router-outlet>
</main>

<app-footer></app-footer>

<button class="top-button" (click)="topFunction()" id="myBtn" title="Go to top" data-toggle="tooltip"
    data-placement="left"><i class="fa fa-angle-up buttonupfun"></i></button>